import { ViewDetails } from '../../models/view-details.model';
import { RequestsTypesConstants } from '../requests-side-menu.constants';
import { TablePropertiesConstants } from '../table-properties.constant';

export class AccountManagerConstants {
    public static INPROGRESS_REQUESTS: ViewDetails = {
        ...RequestsTypesConstants.INPROGRESS_REQUESTS,
        tableColumn: TablePropertiesConstants.ACCOUNTMANAGER_TABLE_COLUMNS,
        tableWithSelection: false
    };

    public static COMPLETED_REQUESTS: ViewDetails = {
        ...RequestsTypesConstants.COMPLETED_REQUESTS,
        tableColumn: TablePropertiesConstants.ACCOUNTMANAGER_TABLE_COLUMNS_WOTH_CLOSED_DATE,
        tableWithSelection: false
    };

    public static EMPLOYEE_MANAGEMENT_REQUESTS: ViewDetails = {
        ...RequestsTypesConstants.EMPLOYEE_MANAGEMENT_REQUESTS,
        tableColumn: TablePropertiesConstants.ACCOUNTMANAGEREMPLOYEEMANAGEMANT_TABLE_COLUMNS,
        tableWithSelection: false
    };
}
